import { useQuery } from "react-query";
import { getTags } from "../api/getTags";

export const useTags = () => {
  return useQuery("tags", getTags);
};
